module.exports = __webpack_public_path__ + "static/media/window-restore-symbolic.179a5bda.svg";